<app-shop-header [hidden]="disableHeader"></app-shop-header>
<router-outlet></router-outlet>
<app-shop-footer [hidden]="disableFooter"></app-shop-footer>
